// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { ReavaliacaoImovel } from './reavaliacao-imovel.model';
import { Imovel } from './imovel.model';

export class ReavaliacaoImovelItem extends BaseResourceModel {
  constructor(
    public id?: number,
    public aux?: number,
    public vida_util_meses?: number,
    public vida_util_meses_anterior?: number,
    public valor_anterior?: number,
    public valor_residual?: number,
    public valor_residual_anterior?: number,
    public valor_cotacao1?: number,
    public valor_cotacao2?: number,
    public valor_cotacao3?: number,
    public valor_reavaliacao?: number,
    public reavaliacao?: ReavaliacaoImovel,
    public imovel?: Imovel,
  ) {
    super();
  }

  static converteJson(json: any): ReavaliacaoImovelItem {
    return Object.assign(new ReavaliacaoImovelItem(), json);
  }
}
